import React from 'react';
import StatusBasedProjects from './StatusBasedProjects';

const AssignedProjects = () => {
  return (
    <StatusBasedProjects 
      status="ASSIGNED"
      title="Assigned Projects"
    />
  );
};

export default AssignedProjects;